<div class="ioteq-vertical-navigation-wrapper" style="background-color: #d3d3d35c;">

    <!-- Header -->
    <div class="ioteq-vertical-navigation-header">
        <ng-content select="[ioteqVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="ioteq-vertical-navigation-content"
        ioteqScrollbar
        [ioteqScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}"
        #navigationContent>

        <!-- Content header -->
        <div class="ioteq-vertical-navigation-content-header">
            <ng-content select="[ioteqVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <ioteq-vertical-navigation-aside-item
                    *ngIf="item.type === 'aside'"
                    [item]="item"
                    [name]="name"
                    [activeItemId]="activeAsideItemId"
                    [autoCollapse]="autoCollapse"
                    [skipChildren]="true"
                    (click)="toggleAside(item)"></ioteq-vertical-navigation-aside-item>

                <!-- Basic -->
                <ioteq-vertical-navigation-basic-item
                    *ngIf="item.type === 'basic'"
                    [item]="item"
                    [name]="name"></ioteq-vertical-navigation-basic-item>

                <!-- Collapsable -->
                <ioteq-vertical-navigation-collapsable-item
                    *ngIf="item.type === 'collapsable'"
                    [item]="item"
                    [name]="name"
                    [autoCollapse]="autoCollapse"></ioteq-vertical-navigation-collapsable-item>

                <!-- Divider -->
                <ioteq-vertical-navigation-divider-item
                    *ngIf="item.type === 'divider'"
                    [item]="item"
                    [name]="name"></ioteq-vertical-navigation-divider-item>

                <!-- Group -->
                <ioteq-vertical-navigation-group-item
                    *ngIf="item.type === 'group'"
                    [item]="item"
                    [name]="name"
                    [autoCollapse]="autoCollapse"></ioteq-vertical-navigation-group-item>

                <!-- Spacer -->
                <ioteq-vertical-navigation-spacer-item
                    *ngIf="item.type === 'spacer'"
                    [item]="item"
                    [name]="name"></ioteq-vertical-navigation-spacer-item>

            </ng-container>

        </ng-container>

        <!-- Content footer -->
        <div class="ioteq-vertical-navigation-content-footer">
            <ng-content select="[ioteqVerticalNavigationContentFooter]"></ng-content>
        </div>

    </div>

    <!-- Footer -->
    <div class="ioteq-vertical-navigation-footer">
        <ng-content select="[ioteqVerticalNavigationFooter]"></ng-content>
    </div>

</div>

<!-- Aside -->
<div
    class="ioteq-vertical-navigation-aside-wrapper"
    *ngIf="activeAsideItemId"
    ioteqScrollbar
    [ioteqScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}"
    [@fadeInLeft]="position === 'left'"
    [@fadeInRight]="position === 'right'"
    [@fadeOutLeft]="position === 'left'"
    [@fadeOutRight]="position === 'right'">

    <!-- Items -->
    <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Aside -->
            <ioteq-vertical-navigation-aside-item
                *ngIf="item.type === 'aside' && item.id === activeAsideItemId"
                [item]="item"
                [name]="name"
                [autoCollapse]="autoCollapse"></ioteq-vertical-navigation-aside-item>

        </ng-container>

    </ng-container>

</div>
